// DS:
// DS1.11
import React from 'react';
import cn from 'classnames';
import PlainButtonOrLink from '../../Buttons/PlainButtonOrLink';
import s from './Dots.scss';

const MINIMUM_PAGES = 2;

interface Props {
  total: number;
  current: number; // first page is 0
  className?: string;
  onClick?: (page: number, e: React.MouseEvent) => void;
}

const Dots: React.FC<Props> = ({ total, current, className, onClick }) => {
  if (total < MINIMUM_PAGES) {
    return null;
  }

  const pages = Array.from(Array(total), (_, i) => i);
  return (
    <div className={cn(s['root'], className)}>
      {pages.map(page => (
        <PlainButtonOrLink
          key={`page-${page}`}
          className={cn(s['dot'], page === current && s['current'])}
          onClick={onClick && (e => onClick(page, e))}
        />
      ))}
    </div>
  );
};
Dots.displayName = 'Dots';

export default Dots;
